/* import __COLOCATED_TEMPLATE__ from './category-name-fields.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./category-name-fields.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));